import { AxiosRequestConfig } from 'axios';
import instance from 'api';

export const npsStart = (config: AxiosRequestConfig) => {
  return instance()
    .post<string>(`/nps/start`, {}, config)
    .then((response) => response.data);
};

export const npsEnabledStart = () => {
  return instance()
    .post<void>(`/nps/enabledStart`)
    .then((response) => response.data);
};

export const npsStop = () => {
  return instance()
    .post<string>(`/nps/stop`)
    .then((response) => response.data);
};

export const npsStatus = () => {
  return instance()
    .post<string>(`/nps/status`)
    .then((response) => response.data);
};
